import { useQuery } from '@tanstack/react-query';
import { partnersApi } from 'App';

type Args = {
  partner?: string;
};

const defaultData = {
  name: 'Name was not found',
  safeBrowserEnabled: false,
  enableSelfService: false,
  showDocumentToPartner: false,
};

export function usePartner({ partner = '' }: Args): {
  name: string;
  safeBrowserEnabled: boolean;
  isLoading: boolean;
  enableSelfService: boolean;
  showDocumentToPartner: boolean;
} {
  const { data, isLoading } = useQuery(['partner', partner], () => partnersApi.get(partner), {
    select: (data) => ({
      name: data.name || 'Name was not found',
      safeBrowserEnabled: data.safeBrowserEnabled,
      enableSelfService: data.enableSelfService && data.active,
      showDocumentToPartner: data.showDocumentToPartner,
    }),
    enabled: !!partner,
  });
  return { ...(data || defaultData), isLoading };
}
